import { ServiceData } from '@/types';

import articles from './YOGA_ARTICLES_CZ.json';
import exercises from './YOGA_EXERCISES_CZ.json';
import recipes from './YOGA_RECIPES_CZ.json';

export const YOGA_DATA_CZ: ServiceData = {
  articles,
  exercises,
  recipes,
};
